"use client"

import { Gift, Sparkles, Sword, Package } from "lucide-react"
import { motion } from "framer-motion"
import Link from "next/link"

export function StarterPromotion() {
    return (
        <section className="py-24 relative overflow-hidden bg-slate-900/50 border-y border-slate-800">
            {/* Background Accents */}
            <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
                <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[400px] h-[400px] bg-blue-600/10 rounded-full blur-[100px]" />
                <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-[400px] h-[400px] bg-indigo-600/10 rounded-full blur-[100px]" />
            </div>

            <div className="container px-4 mx-auto relative z-10">
                <div className="flex flex-col lg:flex-row items-center gap-16">
                    {/* Visual Side */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        className="flex-1 relative"
                    >
                        <div className="relative z-10 grid grid-cols-2 gap-4">
                            <div className="space-y-4">
                                <div className="aspect-square bg-slate-800 border border-slate-700 rounded-3xl flex flex-col items-center justify-center p-6 text-center transform hover:-translate-y-2 transition-transform">
                                    <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center mb-4">
                                        <Sword className="w-8 h-8 text-blue-400" />
                                    </div>
                                    <div className="text-white font-bold text-lg">1M Soulshots</div>
                                    <div className="text-slate-500 text-xs">Essential for battle</div>
                                </div>
                                <div className="aspect-square bg-slate-800 border border-slate-700 rounded-3xl flex flex-col items-center justify-center p-6 text-center translate-x-8 transform hover:-translate-y-2 transition-transform">
                                    <div className="w-16 h-16 bg-indigo-500/20 rounded-2xl flex items-center justify-center mb-4">
                                        <Package className="w-8 h-8 text-indigo-400" />
                                    </div>
                                    <div className="text-white font-bold text-lg">Adventurer Pack</div>
                                    <div className="text-slate-500 text-xs">Full gear set</div>
                                </div>
                            </div>
                            <div className="space-y-4 pt-12">
                                <div className="aspect-square bg-slate-800 border border-slate-700 rounded-3xl flex flex-col items-center justify-center p-6 text-center transform hover:-translate-y-2 transition-transform">
                                    <div className="w-16 h-16 bg-amber-500/20 rounded-2xl flex items-center justify-center mb-4">
                                        <Gift className="w-8 h-8 text-amber-400" />
                                    </div>
                                    <div className="text-white font-bold text-lg">Free Entry</div>
                                    <div className="text-slate-500 text-xs">Beginner friendly</div>
                                </div>
                                <div className="aspect-square bg-slate-800 border border-slate-700 rounded-3xl flex flex-col items-center justify-center p-6 text-center -translate-x-8 transform hover:-translate-y-2 transition-transform">
                                    <div className="w-16 h-16 bg-emerald-500/20 rounded-2xl flex items-center justify-center mb-4">
                                        <Sparkles className="w-8 h-8 text-emerald-400" />
                                    </div>
                                    <div className="text-white font-bold text-lg">EXP Boost</div>
                                    <div className="text-slate-500 text-xs">Level up faster</div>
                                </div>
                            </div>
                        </div>
                        {/* Glow effect under the grid */}
                        <div className="absolute inset-0 bg-blue-500/20 blur-[100px] -z-10 rounded-full" />
                    </motion.div>

                    {/* Content Side */}
                    <div className="flex-1 text-center lg:text-left">
                        <motion.div
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                        >
                            <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-500/10 border border-blue-500/20 rounded-full text-blue-400 text-[10px] font-black uppercase tracking-[0.2em] mb-6">
                                New Player Benefit
                            </div>
                            <h2 className="text-5xl lg:text-7xl font-black text-white tracking-tighter mb-8 leading-none font-cinzel">
                                CLAIM YOUR <span className="text-blue-500 text-glow">REWARD</span>
                            </h2>
                            <p className="text-slate-400 text-xl font-medium mb-10 leading-relaxed max-w-xl italic">
                                Every new legend deserves a legendary start. Register your account today and
                                receive a massive booster pack absolutely free. No strings attached.
                            </p>

                            <div className="flex flex-col sm:flex-row items-center gap-6 justify-center lg:justify-start">
                                <Link
                                    href="/register"
                                    className="px-10 py-5 bg-blue-600 hover:bg-blue-500 text-white font-bold rounded-xl transition-all shadow-lg shadow-blue-900/40 active:scale-95 text-lg font-cinzel"
                                >
                                    GET STARTED NOW
                                </Link>
                                <div className="text-slate-500 text-sm flex items-center gap-2">
                                    <div className="w-2 h-2 bg-green-500 rounded-full" />
                                    Instant account creation
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    )
}
